import { LogLevels, createConsoleLogger } from '@powersync/common';
import { serializeErrorForRelay } from '@powersync/shared-internals';
/**
 * Broadcasts logs to all clients
 */
export class BroadcastLogger {
    clients;
    inner;
    currentLevel = LogLevels.info;
    sequence = 0;
    sendBroadcasts = true;
    constructor(prefix, clients) {
        this.clients = clients;
        this.inner = createConsoleLogger({ prefix: prefix });
    }
    log(record) {
        this.inner.log(record);
        if (this.sendBroadcasts && record.level >= this.currentLevel) {
            const sanitized = this.sanitizeRecord(record);
            this.iterateClients((client) => client.clientProvider.log(sanitized));
        }
    }
    /**
     * Set the global log level.
     */
    setLevel(level) {
        this.inner.minLevel = level;
        this.currentLevel = level;
    }
    /**
     * Iterates all clients, catches individual client exceptions
     * and proceeds to execute for all clients.
     */
    async iterateClients(callback) {
        for (const client of this.clients) {
            try {
                await callback(client);
            }
            catch (ex) {
                console.error('Caught exception when iterating client', ex);
            }
        }
    }
    sanitizeRecord(record) {
        // Preserve explicit undefined rejection reasons.
        if (!('error' in record)) {
            return record;
        }
        const serialized = serializeErrorForRelay(record.error);
        return {
            ...record,
            error: {
                ...serialized,
                relay: {
                    origin: 'shared-sync-worker',
                    sequence: this.sequence++,
                    errorState: serialized.state,
                    relayedAt: new Date().toISOString()
                }
            }
        };
    }
}
//# sourceMappingURL=BroadcastLogger.js.map